import React from 'react'
import Scrollspy from 'react-scrollspy'
import ReactAudioPlayer from 'react-audio-player'
import Scroll from '../Scroll';


import {
	Collapse,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	NavItem,
	NavLink,
} from 'reactstrap';


export default class NavigationMenuScrollSpy extends React.Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.state = {
			isOpen: false
		};
	}
	
	toggle() {
		if(window.innerWidth<768) {
			this.setState({
				isOpen: !this.state.isOpen
			});
		}
	}

	render() {
		return (
			<>
				<Navbar className="fixed-top" dark expand="md">
					<div className="container">
						<NavbarBrand href="/" className="d-block d-md-none mr-auto">AG</NavbarBrand>
						<NavbarToggler onClick={this.toggle} className="mr-2" aria-label="Ouvrir/Fermer le menu navigation" />
						<Collapse isOpen={this.state.isOpen} navbar>
							<Scrollspy className="mr-auto navbar-nav" items={['presentation', 'formation', 'competences', 'experiences', 'realisations', 'contact']} currentClassName="active">
								<NavItem onClick={this.toggle}>
									<Scroll type="id" element="presentation">
										<NavLink href="#presentation" aria-label="Présentation de Alexandre GADIOU" >
											<i className="fa fa-home" aria-hidden="true"></i>
										</NavLink>
									</Scroll>
								</NavItem>
								<NavItem onClick={this.toggle}>
									<Scroll type="id" element="formation">
										<NavLink href="#formation" >Formation</NavLink>
									</Scroll>
								</NavItem>
								<NavItem>
									<Scroll type="id" element="competences">
										<NavLink onClick={this.toggle} href="#competences" >Compétences</NavLink>
									</Scroll>
								</NavItem>
								<NavItem onClick={this.toggle}>
									<Scroll type="id" element="experiences">
										<NavLink href="#experiences" >Expériences</NavLink>
									</Scroll>
								</NavItem>
								<NavItem onClick={this.toggle}>
									<Scroll type="id" element="realisations">
										<NavLink href="#realisations" >Réalisations</NavLink>
									</Scroll>
								</NavItem>
								<NavItem onClick={this.toggle}>
									<Scroll type="id" element="contact">
										<NavLink href="#contact" >Contact</NavLink>
									</Scroll>
								</NavItem>
							</Scrollspy>
						</Collapse>
					</div>
				</Navbar>
				<ReactAudioPlayer
					id="audio-player"
					className="audio-player"
					src="ever-felt-pt2-otis-mcdonald.mp3"
					autoPlay
					controls
				/>
		  </>
		);
	}
}